var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-map',{ref:"mapRef",staticClass:"item-map",attrs:{"center":{lat: _vm.item.latitude, lng: _vm.item.longitude},"zoom":12}},[_c('gmap-marker',{attrs:{"position":{lat: _vm.item.latitude, lng: _vm.item.longitude}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }